//
// AgeGateUIPolicy.js
//
// This function component is responsible for deciding the state of the app
// It provides the following methods that assist with this
// a. getInitialGeoState:
//      For countries with the geo states dropdown visible, the app needs to
//      figure out the initial state to select in the dropdown. This is
//      to be done based on the geolocation of the user and the states list
//      received from the backend service. This method helps with the decision.
// b. isWarrantyAgeGate:
//      We currently have two different workflows for the age gate based on
//      whether a user is on a `warranty age gate enabled page` or not.
//      This method assists us with the decision.
// c. isTriggerStatePricingEnabled:
//      For the US currently, the backend service needs to know which state the
//      user resides in, for tax pricing purposes. The app calls a backend
//      api for this. This method assists with the decision as to whether the
//      backend api needs to be called.
// d. shouldDisableAgreeButton:
//      Currently for some blocked states/provinces like quebec, we need to
//      not allow the user to verify his age (to get to the full shop site).
//      This method assists us with the above decision.
// e. shouldShowRouteToLocatorButton:
//      There are some provinces where we need to route the user to the store
//      locator url from the age gate. Since thats the only functionality that
//      the store should have. This method assists us with the decision.
// f. shouldShowBlockedStateWarning:
//      For some blocked states like quebec, we need to show a warning message
//      (required by compliance). This method assists us with this decision.
export const AgeGateUIPolicy = ({
  header: {} = {},
  body: { agree, blocked_state_warning, blocked_states, selector } = {},
  footer: {} = {},
  properties,
  windowLocation,
  geolocation,
}) => {
  // Below URLs are understood as warranty urls
  // We will attempt to launch the warranty age gate for these urls
  // (if warranty age gate is enabled for the store)
  const WARRANTY_URLS = /(claim-warranty|signin|authentication|account|signup)/;

  return {
    getInitialGeoState: () => {
      const getStateFromDropdown = () => {
        return (
          selector &&
          selector.states && // Get GeoLocation State From List of States
          ((geolocation &&
            selector.states.filter(
              e => e.value === geolocation.state_abbr
            )[0]) ||
            // Get the first state from the List of States
            selector.states[0])
        );
      };

      const getTheGeoState = () =>
        geolocation && {
          label: geolocation.city,
          value: geolocation.state_abbr,
        };

      const getEmptyStateHash = () => ({ label: '', value: '' });

      return getStateFromDropdown() || getTheGeoState() || getEmptyStateHash();
    },
    isWarrantyAgeGate: () =>
      !!properties &&
      !!properties.is_warranty_enabled &&
      !!windowLocation.pathname.match(WARRANTY_URLS),
    isTriggerStatePricingEnabled: () => {
      return !!agree && !!agree.trigger_state_pricing;
    },
    shouldDisableAgreeButton: selectedState =>
      !!agree &&
      !!agree.disable_for_blocked_states &&
      blocked_states &&
      blocked_states.includes(selectedState.value),
    shouldShowRouteToLocatorButton: selectedState =>
      !!agree &&
      !!agree.route_to_locator_for_blocked_states &&
      blocked_states &&
      blocked_states.includes(selectedState.value),
    shouldShowBlockedStateWarning: selectedState =>
      blocked_state_warning &&
      blocked_states &&
      blocked_states.includes(selectedState.value),
  };
};
